export function useChannelSubscriptions() {
  const listQuery = useQuery(queries().teamMode.subscriptions);

  return { listQuery };
}
